<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t('turnover') }} {{ $t(type) }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @getAllRows="getAllRows"
          >
          <export-excel
            ref="refExcel"
            :data="excelItems"
            worksheet="abriron.com"
            name="data.xls"
            type="xls"
            class="float-left d-flex"
            :title="$store.state.abrName"
            :total-prop="pageCount"
            :page-prop="excelPage"
            @getAllRows="getAllRows"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excel')" />
          </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="goTo(type)"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn
          outlined
          class="mt-4 ms-2"
          color="grey darken-2 "
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('excel') }}
          </p>
          <v-icon>
            mdi-file-excel-outline
          </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-6': !isMobile && !isTablet , 'mt-0': isMobile || isTablet}"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :hide-default-header="isMobile || mobileShow"
        :loading="loading"
        :page.sync="page"
        multi-sort
        dense
        :show-expand="(showInvoiceDetail ? false : false)"
        :expanded.sync="expanded"
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template
          v-if="isMobile"
          v-slot:item="{ item, index }"
        >
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': (item.debtor > 0 ? true : false ),
                  'mobile-td-list-border-green': (item.creditor > 0 ? true : false ),
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/pay/cash/edit/' + item.id"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.content }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('number') }} : {{ (item.head ? item.head.number : '' ) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('date') }} : {{ (item.date ? item.date : item.head.date ) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn
                    v-if="item.debtor > 0"
                    dark
                    text
                    small
                    color="red"
                  >
                    {{ (currencyFilter && currencyFilter !== $store.state.currency.id ? $numberFormat(item.debtor_currency) : $numberFormat(item.debtor) ) }} {{ $t('debtor') }}
                  </v-btn>
                  <v-btn
                    v-if="item.creditor > 0"
                    dark
                    text
                    small
                    color="green"
                  >
                    {{ (currencyFilter && currencyFilter !== $store.state.currency.id ? $numberFormat(item.creditor_currency) : $numberFormat(item.creditor) ) }} {{ $t('creditor') }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td
            style="background-color: cornsilk;"
            :colspan="showHeaders.length + 1"
          >
            <div
              v-if="item.reference && item.reference.article"
              class="mb-4"
            >
              <v-simple-table
                dense
                style="background-color: cornsilk;"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        :colspan="showHeaders.length-5"
                      >
                        {{ $t('product-name') }}
                      </th>
                      <th>
                        {{ $t('count') }}
                      </th>
                      <th>
                        {{ $t('fee') }}
                      </th>
                      <th>
                        {{ $t('discount') }}
                      </th>
                      <th>
                        {{ $t('tax') }}
                      </th>
                      <th>
                        {{ $t('sum') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(article, i) in item.reference.article"
                      :key="i"
                    >
                      <td :colspan="showHeaders.length-5">
                        {{ article.product.name }}
                      </td>
                      <td>
                        {{ article.count }}
                      </td>
                      <td>
                        {{ $numberFormat(article.fee) }}
                      </td>
                      <td>
                        {{ $numberFormat(article.discount) }}
                      </td>
                      <td>
                        {{ $numberFormat(article.tax) }}
                      </td>
                      <td>
                        {{ $numberFormat(+(article.count * article.fee) - +article.discount + +article.tax) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.debtor="{ item }">
          {{ (currencyFilter && currencyFilter !== $store.state.currency.id ? $numberFormat(item.debtor_currency) : $numberFormat(item.debtor) ) }}
        </template>
        <template v-slot:item.contentTurnover="{ item }">
          <div class="d-flex">
            <a
              v-if="item.head.ref_type !== 'transfer'"
              @click="openPrint(item)"
            >
              {{ item.content }}
            </a>
            <a
              v-if="item.head.ref_type === 'transfer'"
              @click="openPrint(item)"
            >
              {{ (!showSummaryTransferContent ? item.content : $t('transferDocumentFrom') + ' ' + (item.fin4 ? item.fin4.name : '')) }}
            </a>
          </div>
          <v-chip
            v-if="item.reference"
            color="primary"
            outlined
            small
            class="px-1 ms-0 mb-1"
            @click="goToLink(item.reference.url)"
          >
            <span class="px-1">
              {{ $t(item.reference.type) }} {{ (item.reference.number ? $t('number') + ':' + item.reference.number : item.reference.id) }}
            </span>
            <v-icon x-small>
              mdi-link-variant
            </v-icon>
          </v-chip>
          <div
            v-if="item.reference && item.reference.article && showInvoiceDetail"
            class="mb-4"
          >
            <v-simple-table
              dense
              class="v-data-table__wrapper__height_off"
              style="background-color: #e3e3e3;min-height: auto !important;"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-center"
                    >
                      {{ $t('product-name') }}
                    </th>
                    <th class="text-center">
                      {{ $t('count') }}
                    </th>
                    <th class="text-center">
                      {{ $t('fee') }}
                    </th>
                    <th class="text-center">
                      {{ $t('sum') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(article, i) in item.reference.article"
                    :key="i"
                  >
                    <td
                      class="text-center"
                    >
                      {{ article.product.name }}
                    </td>
                    <td class="text-center">
                      {{ $numberFormat(article.count) }}
                    </td>
                    <td class="text-center">
                      {{ $numberFormat(article.fee) }}
                    </td>
                    <td class="text-center">
                      {{ $numberFormat((+(article.count * article.fee) - + article.discount + +article.tax).toFixed($store.state.currency.decimal)) }}
                    </td>
                  </tr>
                  <tr v-if="item.reference.discount && item.reference.discount > 0">
                    <td
                      colspan="2"
                      class="text-center"
                    >
                      {{ $t('discount') }}
                    </td>
                    <td class="text-center" />
                    <td class="text-center">
                      {{ $numberFormat(item.reference.discount) }}-
                    </td>
                  </tr>
                  <tr v-if="item.reference.tax && item.reference.tax > 0">
                    <td
                      colspan="2"
                      class="text-center"
                    >
                      {{ $t('tax') }}
                    </td>
                    <td class="text-center" />
                    <td class="text-center">
                      {{ $numberFormat(item.reference.tax) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div
            v-if="item.reference && item.reference.content"
            class="mb-1"
          >
            {{ item.reference.content }}
          </div>
        </template>
        <template v-slot:item.head.date="{ item }">
          {{ (item.date ? item.date : item.head.date ) }}
        </template>
        <template v-slot:item.creditor="{ item }">
          {{ (currencyFilter && currencyFilter !== $store.state.currency.id ? $numberFormat(item.creditor_currency) : $numberFormat(item.creditor) ) }}
        </template>
        <template v-slot:item.currency="{ item }">
          {{ (item.currency ? item.currency.symbol : '') }}
        </template>
        <template v-slot:item.payed.paymentsAmount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.paymentsAmount : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.payed.checksAmount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.checksAmount : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat((item.tax ? item.tax : 0)) }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat((item.discount ? item.discount : 0)) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.fin4="{ item }">
          {{ (item.fin4 ? item.fin4.name : '') }}
        </template>
        <template v-slot:item.fin5="{ item }">
          {{ (item.fin5 ? item.fin5.name : '') }}
        </template>
        <template v-slot:item.fin6="{ item }">
          {{ (item.fin6 ? item.fin6.name : '') }}
        </template>
        <template v-slot:item.head.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.head.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.head.last_status="{ item }">
          <v-chip
            v-if="item.head.last_status && item.head.last_status.status"
            :color="item.head.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.head.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.remainStatus="{ item }">
          {{ statusLabel(item) }}
        </template>
        <template v-slot:item.sumAmount="{ item }">
          {{ $numberFormat(+item.cumulative_debtor - +item.cumulative_creditor + +item.initial) }}
        </template>
        <template
          v-slot:body.preppend
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6: (accountProp ? 6 : 7)}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('debtor') + ':' : '') }} {{ $numberFormat(totals.debtor) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('creditor') + ':' : '') }} {{ $numberFormat(totals.creditor) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ $t('sumInPage') }} : {{ $numberFormat(parseFloat(totals.debtor)-parseFloat(totals.creditor)) }}
            </td>
            <td
              :colspan="`${isMobile?6:4}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?7: (accountProp ? 8 : 9)}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('debtor') + ':' : '') }} {{ $numberFormat(totals.debtor) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('creditor') + ':' : '') }} {{ $numberFormat(totals.creditor) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <!--              {{ $t('sumInPage') }} : {{ $numberFormat(parseFloat(totals.debtor)-parseFloat(totals.creditor)) }}-->
            </td>
            <td
              v-if="!isMobile"
              :colspan="`${isMobile?6:4}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="given"
              title="given"
              type="given"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="fin4"
              title="detail"
              type="detail"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="fin5"
              title="fin5"
              type="detail"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="fin6"
              title="fin6"
              type="detail"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="currencyFilter"
              title="currency"
              type="currency"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-checkbox
              v-model="showInvoiceDetail"
              class="mt-0"
              :label="$t('showInvoiceDetail')"
              value="active"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-checkbox
              v-model="showSummaryTransferContent"
              class="mt-0"
              :label="$t('showSummaryTransferContent')"
              value="active"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="setFilter"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <div style="position: fixed;z-index: 2">
            <v-btn
              icon
              color="grey darken-2"
              @click="printDialog = false"
            >
              <v-icon
                class="close-hover"
                large
              >
                mdi-close
              </v-icon>
            </v-btn>
          </div>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :show-summary-transfer-content-prop="showSummaryTransferContent"
            :turnover-prop="totals"
            :from-date="fromDate"
            :to-date="toDate"
            :data-prop="{
              showInvoiceDetail: showInvoiceDetail
            }"
            :title="$t('turnover') + ' ' + (account ? account : (accountProp ? accountProp.name : ''))"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <dialog-component
      :dialog-prop="innerComponent"
      @close="innerComponent = false"
    />
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  export default {
    name: 'Turnover',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      autocomplete,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'accountProp', 'idProp', 'selfProp', 'givenProp', 'fin5Prop', 'fin6Prop', 'mobileShow'],
    data: () => ({
      expanded: [],
      excelItems: [],
      selected: [],
      pageCount: 1,
      page: 1,
      printDialog: false,
      deletDialog: false,
      showSelect: true,
      sumAmount: 0,
      showSummaryTransferContent: null,
      sumAmountPreviousPage: 0,
      filter: false,
      showInvoiceDetail: null,
      productStatus: null,
      fromDate: null,
      toDate: null,
      productStatusItems: null,
      currencyFilter: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      account: null,
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      printHeaders: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      fin4: null,
      fin5: null,
      fin6: null,
      prePage: 1,
      pageData: [],
      given: null,
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.accountProp) {
            if (s.value === 'fin4.name' || s.value === 'given.name') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        const totals = this.items.reduce((acc, d, index) => {
          acc.debtor += (d.debtor ? (this.currencyFilter && this.currencyFilter !== this.$store.state.currency.id ? parseFloat(d.debtor_currency) : parseFloat(d.debtor)) : 0)
          acc.creditor += (d.creditor ? (this.currencyFilter && this.currencyFilter !== this.$store.state.currency.id ? parseFloat(d.creditor_currency) : parseFloat(d.creditor)) : 0)
          return acc
        }, {
          debtor: 0,
          creditor: 0,
        })
        return totals
      },
    },
    watch: {
      fin5Prop (val) {
        this.fin5 = this.fin5Prop
        this.getItems()
      },
      fin6Prop (val) {
        this.fin6 = this.fin6Prop
        this.getItems()
      },
      accountProp (val) {
        this.getItems()
      },
      givenProp (val) {
        this.getItems()
      },
      idProp () {
        this.sumAmount = 0
        this.getItems()
      },
      refId (val, oldVal) {
        // this.items = []
        this.sumAmount = 0
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.sumAmount = 0
          app.pageData = []
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      // this.sumAmount = 0
      // this.pageData = []
      // this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'purchaseList') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'presaleList') {
        this.type = 'presale'
      }
      if (this.$route.name === 'sellList') {
        this.type = 'sell'
      }
      if (this.$route.name === 'purchaseReturnList') {
        this.type = 'purchaseReturn'
      }
      if (this.$route.name === 'sellReturnList') {
        this.type = 'sellReturn'
      }
      this.headers = [
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 50,
        },
        {
          text: this.$t('number'),
          sortable: true,
          value: 'head.number',
          table: 'doc_header.number',
          width: 70,
        },
        {
          text: this.$t('content'),
          sortable: false,
          value: 'contentTurnover',
          width: 250,
        },
        {
          text: this.$t('date'),
          sortable: true,
          value: 'head.date',
          table: 'doc_header.date',
          width: 100,
        },
        {
          text: this.$t('given'),
          sortable: true,
          value: 'given.name',
          table: 'financial_given_coding.name',
          width: 150,
        },
        {
          text: this.$t('fin4'),
          sortable: true,
          value: 'fin4',
          table: 'financial_detail_coding.name',
          width: 90,
        },
        {
          text: this.$t('fin5'),
          sortable: true,
          value: 'fin5',
          table: 'financial_detail_coding.name',
          width: 90,
        },
        {
          text: this.$t('fin6'),
          sortable: true,
          value: 'fin6',
          table: 'financial_detail_coding.name',
          width: 90,
        },
        {
          text: this.$t('debtor'),
          sortable: true,
          value: 'debtor',
          table: 'doc_article.debtor',
          width: 120,
        },
        {
          text: this.$t('creditor'),
          sortable: true,
          value: 'creditor',
          table: 'doc_article.creditor',
          width: 120,
        },
        {
          text: this.$t('remain'),
          sortable: false,
          value: 'sumAmount',
          width: 150,
        },
        {
          text: this.$t('status'),
          value: 'remainStatus',
          width: 70,
        },
        {
          text: this.$t('currency'),
          sortable: false,
          value: 'currency',
          width: 80,
        },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'head.tags',
          width: 100,
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
          width: 100,
        },
      ]
      this.printHeaders = [
        {
          text: this.$t('number'),
          value: 'head',
          width: 5,
        },
        {
          text: this.$t('content'),
          value: 'contentTurnover',
          width: 20,
        },
        {
          text: this.$t('date'),
          value: 'head.date',
          width: 10,
        },
        {
          text: this.$t('given'),
          value: 'given',
          width: 10,
        },
        {
          text: this.$t('fin4'),
          value: 'fin4',
          width: 10,
        },
        {
          text: this.$t('debtor'),
          value: 'debtor',
          width: 10,
          type: 'number',
          sum: true,
        },
        {
          text: this.$t('creditor'),
          value: 'creditor',
          width: 10,
          type: 'number',
          sum: true,
        },
        {
          text: this.$t('remain'),
          value: 'remain',
          width: 15,
          type: 'number',
        },
        {
          text: '',
          value: 'remainStatus',
          width: 5,
        },
      ]
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      if (this.fin5Prop) {
        this.fin5 = this.fin5Prop
      }
      if (this.fin6Prop) {
        this.fin6 = this.fin6Prop
      }
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
    },
    mounted () {
    },
    methods: {
      statusLabel (item) {
        const total = +item.cumulative_debtor - +item.cumulative_creditor + +item.initial
        if (total > 0) {
          return this.$t('deb')
        } else if (total < 0) {
          return this.$t('cred')
        } else {
          return ''
        }
      },
      openPrint (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting', {
          params: {
            print: 'active',
            id: [item.head_id],
            type: 'document2',
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: 'reportViewer', params: { dataProp: res, reportProp: 'document2' } })
            app.printItems = []
            // var routeData = app.$router.resolve({ name: 'reportViewer', params: { dataProp: res } })
            // window.open(routeData.href, '_blank')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      setFilter () {
        this.sumAmount = 0
        this.pageData = []
        this.getItems()
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'accountingEdit', params: { id: item.head_id } })
      },
      getItems () {
        if (this.$store.state.teacherAccess && this.selfProp === undefined) {
          return false
        }
        var app = this
        app.filter = false
        app.loading = true
        if (app.givenProp) {
          app.given = app.givenProp
        }
        app.$axios.get(this.$endpoint + 'accountingreport', {
          params: {
            fin4: (app.fin4 ? app.fin4.id : null),
            fin5: (app.fin5 ? app.fin5.id : null),
            fin6: (app.fin6 ? app.fin6.id : null),
            given: (app.given ? app.given.id : null),
            idProp: app.idProp,
            account: (app.$route.name === 'turnoverDetail' && app.$route.params.id ? { fin_id: app.$route.params.id } : app.accountProp),
            fromDate: app.fromDate,
            showInvoiceDetail: app.showInvoiceDetail,
            branch: app.branch,
            toDate: app.toDate,
            search: app.search,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            type: app.type,
            report: 'turnover',
            sortBy: app.sortBy,
            self: app.selfProp,
            status: app.productStatus,
            options: app.options,
            currency: app.currencyFilter,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (app.options.page === 1) {
              app.sumAmount = 0
              app.pageData = []
            }
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
            if (app.options.page > 1) {
              const index = app.pageData.findIndex(h => h.page === parseInt(app.options.page))
              if (index > -1) {
                const i = app.pageData.findIndex(h => h.page === parseInt(app.options.page) - parseFloat(1))
                app.sumAmount = app.pageData[i].sum
              }
            }
            app.items.map(function (value, key) {
              if (app.currencyFilter && app.currencyFilter !== app.$store.state.currency.id) {
                app.sumAmount = parseFloat(app.sumAmount) + (value.debtor_currency ? parseFloat(value.debtor_currency) : 0) - (value.creditor_currency ? parseFloat(value.creditor_currency) : 0)
              } else {
                app.sumAmount = parseFloat(app.sumAmount) + (value.debtor ? parseFloat(value.debtor) : 0) - (value.creditor ? parseFloat(value.creditor) : 0)
              }
              value.sum = app.sumAmount
            })
            if (app.options.page > 1) {
              const index = app.pageData.findIndex(h => h.page === parseInt(app.options.page))
              if (index > -1) {
                // const i = app.pageData.findIndex(h => h.page === parseInt(app.options.page) - parseFloat(1))
                // app.sumAmount = app.pageData[i].sum
              } else {
                app.pageData.push({ page: app.options.page, sum: app.sumAmount })
              }
            } else {
              app.pageData.push({ page: app.options.page, sum: app.sumAmount })
            }
            if (app.$route.params.id) {
              app.account = app.items[0].fin4.name
            } else {
              app.account = null
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            date: (d.head ? d.head.date : ''),
            number: (d.head ? d.head.number : ''),
            gdate: (d.head ? d.head.g_date : ''),
            content: (d.content ? d.content : ''),
            given: (d.given ? d.given.name : ''),
            fin4: (d.fin4 ? d.fin4.name : ''),
            fin5: (d.fin5 ? d.fin5.name : ''),
            fin6: (d.fin6 ? d.fin6.name : ''),
            debtor: (d.debtor ? d.debtor : ''),
            creditor: (d.creditor ? d.creditor : ''),
          })
        })
      },
    },
  }
</script>

<style scoped>
div.v-data-table__wrapper {
  min-height: 50px !important;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
